// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: 3.2,
  firebase: {
    apiKey: "AIzaSyBef0FLTJHDj2xbJrORnMAnIhQlAnuBfqE",
    authDomain: "virtus-autenticacao.firebaseapp.com",
    databaseURL: "https://virtus-autenticacao.firebaseio.com",
    projectId: "virtus-autenticacao",
    storageBucket: "virtus-autenticacao.appspot.com",
    messagingSenderId: "633799651531",
    appId: "1:633799651531:web:776c883360df8caa4deb4e",
    measurementId: "G-XCX9762929",
  },
  user: null,
  selected: null,
  vendas: "https://contratos.plataformavirtus.com.br",
  logs: "https://logs.plataformavirtus.com.br",
  cobranca: "https://cobranca.plataformavirtus.com.br",
  cobranca_novo: "https://api-virtus-prod.plataformavirtus.com.br/cobranca",
  backend_virtus: "https://api-virtus-prod.plataformavirtus.com.br",
  sso: "https://sso.plataformavirtus.com.br",
  relatorios: "https://relatorios.plataformavirtus.com.br",
  apiUrl: "https://api.plataformavirtus.com.br",
};
